import React from 'react';
import { Modal, Button, Row, Col, Card } from '@/components/ui';
import ResponsiveModal from '../../../quantified-tracking/components/ResponsiveModal';

interface TaskTypeSelectionModalProps {
  show: boolean;
  onClose: () => void;
  onSelect: (type: 'Routine' | 'Quantified' | 'Overhead') => void;
}

const TaskTypeSelectionModal: React.FC<TaskTypeSelectionModalProps> = ({
  show,
  onClose,
  onSelect
}) => {
  const getTaskTypeIcon = (type: 'Routine' | 'Quantified' | 'Overhead') => {
    switch (type) {
      case 'Routine':
        return 'bi-calendar-check';
      case 'Quantified':
        return 'bi-calculator';
      case 'Overhead':
        return 'bi-briefcase';
      default:
        return 'bi-gear';
    }
  };

  const getTaskTypeDescription = (type: 'Routine' | 'Quantified' | 'Overhead') => {
    switch (type) {
      case 'Routine':
        return 'Create a recurring routine task with fixed allocations for labor, materials, and equipment';
      case 'Quantified':
        return 'Create a recurring quantified task with variable quantities and unit-based measurements';
      case 'Overhead':
        return 'Create an overhead task for administrative and indirect costs';
      default:
        return '';
    }
  };

  if (!show) return null;

  return (
    <ResponsiveModal
      isOpen={show}
      onClose={onClose}
      title="Select Standing Task Type"
      footer={
        <Button
          type="button"
          variant="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>
      }
    >
      <Row>
        {(['Routine', 'Quantified', 'Overhead'] as const).map((type) => (
          <Col key={type} md={4}>
            <Card
              className="tw-h-full cursor-pointer"
              onClick={() => onSelect(type)}
              style={{ cursor: 'pointer' }}
            >
              <Card.Body>
                <div className="tw-flex tw-items-center tw-mb-2">
                  <i className={`bi ${getTaskTypeIcon(type)} fs-4 tw-mr-2`}></i>
                  <h5 className="card-title tw-mb-0">Standing {type} Task</h5>
                </div>
                <p className="card-text tw-text-content-muted">
                  {getTaskTypeDescription(type)}
                </p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </ResponsiveModal>
  );
};

export default TaskTypeSelectionModal; 